import { Duplexer } from '@wix/duplexer-js';
import { APP_DEF_ID, DUPLEXER_ENDPOINT } from '@wix/live-video-commons';
export class DuplexerConnection {
    constructor({ channel, instanceUpdater }) {
        this.ready = new Promise(resolve => {
            const duplexer = new Duplexer(DUPLEXER_ENDPOINT, {
                instanceUpdater,
            });
            this.connection = duplexer.connect({ appDefId: APP_DEF_ID });
            this.connection.on('@duplexer:connected', () => {
                const { channelName, resourceId } = channel;
                this.channel = this.connection.subscribe(channelName, {
                    resourceId,
                });
                this.channel.on('@duplexer:subscription_succeeded', () => {
                    resolve();
                });
            });
        });
    }
    async on(eventName, cb) {
        await this.ready;
        this.channel.on(eventName, cb);
    }
    async send(eventName, payload = {}) {
        if (!eventName.startsWith('client-')) {
            throw new Error('Client event must start with "client-"');
        }
        await this.ready;
        return this.channel.send(eventName, payload);
    }
    disconnect() {
        var _a, _b;
        (_a = this.channel) === null || _a === void 0 ? void 0 : _a.off();
        (_b = this.connection) === null || _b === void 0 ? void 0 : _b.disconnect();
    }
}
//# sourceMappingURL=duplexer.js.map